import type { SVGProps } from 'react';

export const FormatBold = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.85 18.625c-.417 0-.775-.142-1.075-.425a1.542 1.542 0 0 1-.425-1.1V6.9c0-.433.142-.792.425-1.075.3-.3.658-.45 1.075-.45h3.35c1.017 0 1.933.317 2.75.95.833.633 1.25 1.492 1.25 2.575 0 .733-.183 1.342-.55 1.825-.35.467-.733.808-1.15 1.025.5.167.983.517 1.45 1.05.467.517.7 1.217.7 2.1 0 1.283-.475 2.225-1.425 2.825-.933.6-1.875.9-2.825.9H8.85Zm.65-2h2.825c.783 0 1.333-.217 1.65-.65.333-.433.5-.85.5-1.25s-.167-.817-.5-1.25c-.317-.45-.883-.675-1.7-.675H9.5v3.825Zm0-5.75h2.575c.617 0 1.1-.175 1.45-.525.35-.35.525-.767.525-1.25 0-.517-.192-.933-.575-1.25-.367-.333-.817-.5-1.35-.5H9.5v3.525Z" />
    </svg>
  );
};
